const useSystemsStyles = () => {
    return {
        systemsCardStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 1.5,
            gap: 1
        }
    };
};
export default useSystemsStyles;
